import type { Prototype } from "../prototype-types";

export const abhishekRaiPrototypes: Prototype[] = [
  {
    id: "ar-not-featured-home-card",
    name: "F30D M1 — Not-featured home card",
    path: "/ar/not-featured-home-card",
    description:
      "M1 single-action not-featured card: four variants across Day 0, Day 5 and Day 13 of the 14-day qualifying window.",
    owner: "Abhishek Rai",
    project: "F30D Brand Education",
    figmaLink:
      "https://www.figma.com/design/GpfLn2dXRQSY6JZq88l8tK/Brand-Portal-F30D?node-id=1272-32037",
    createdAt: "2026-11-04",
    lastUpdated: "2026-11-04",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/d869e1a2037c6669bd6f081b938708d475ce2ac1efe93789ed7ac4fa639c8352.png",
  },
];
